export default {
  setOauth({ commit }, payload) {
    commit('SET_OAUTH', payload);
  },

  clearOauth({ commit }, payLoad) {
    commit('SET_OAUTH', {
      naver: null,
      kakao: null,
      facebook: null,
      user: {
        memberId: null,
        oauthUid: null,
        provider: null,
      },
    });
  },
};
